<template>
	<div id="arrow-container">
			<label class="arrow-label clickable" @click="linkTo()">
				<img :src="arrowIcon"/>
			</label>
	</div>
</template>

<script>
	export default {
		name: 'LandingArrowLabel',
		data: 
			function() {
				return {
					contact: "Kontakt",
					arrowIcon: require('../../../assets/Icons/CIB+ Pfeil.svg'),
			}
		},
		methods: {
			linkTo() {
				window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
			}
		},
	
	
	
	mounted() {
		var el = document.getElementById("arrow-container");
		el.style.display = "none";
		el.style.opacity = 0;
		
	}
}
</script>

<style scoped>
	#arrow-container {
		position: fixed;
		bottom: 75px;
		right: 75px;
		z-index: 1001;
		transition: all 0.5s ease-out;
	}

	.arrow-label {
		width:60px;
		position: absolute;
		left: 0;
		text-align: center;
		z-index:100;
	}

	@media (max-width: 991px) {
		.arrow-label {
			width: 50px;
		}
		#arrow-container {
			bottom: 60px;
			right: 60px;
		}
	}

	@media (max-width: 767px) {
		.arrow-label {
			width:35px;
			}
		}

	@media (max-width: 575px) {
		.arrow-label {
			width:30px;
		}
	}

</style

>